import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { NavigationEffects } from './+state/navigation.effects';
import { NAVIGATION_FEATURE_KEY, reducer } from './+state/navigation.reducer';
import { AppNavigationConfig } from './app-navigation-config';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(NAVIGATION_FEATURE_KEY, reducer),
    EffectsModule.forFeature([NavigationEffects]),
  ],
})
export class AppNavigationModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: AppNavigationModule
  ) {
    if (parentModule) {
      throw new Error(
        'AppNavigationModule is already loaded. Import only in AppModule'
      );
    }
  }

  static forRoot(
    config: AppNavigationConfig
  ): ModuleWithProviders<AppNavigationModule> {
    return {
      ngModule: AppNavigationModule,
      providers: [
        {
          provide: AppNavigationConfig,
          useValue: config,
        },
      ],
    };
  }
}
